import React from "react";
import PropTypes from "prop-types";
import { RadioSurveyFS } from "./RadioButtonComponent.styled";

const RadioButtonComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestion,
  idQuestion,
  internalCode,
  typeQuestion,
  configuration,
  answerConfiguration,
  question,
  answersDependent,
  setAnswersDependent,
  surveyQuestionData,
  QuestionsSave,
  setQuestionsSave,
}) => {
  const handleRadioChange = () => {
    const position = answersDependent.findIndex(
      (f) => f.idQuestionSurvey === question.idQuestionSurvey
    );

    if (position > -1) {
      const updatedQuestionsSave = QuestionsSave.filter(
        (q) => !surveyQuestionData.find((f) => f.idQuestion === q.idQuestion)
      );

      setQuestionsSave(updatedQuestionsSave);
      answersDependent[position].answer = elementValue;
    } else {
      const updatedAnswersDependent = {
        idQuestionSurvey: question.idQuestionSurvey,
        answer: elementValue,
      };

      setAnswersDependent([updatedAnswersDependent]);

      setAnswerQuestion(elementValue, idQuestion, internalCode, typeQuestion);
    }
  };

  const labelStyle = configuration.customStyle
    ? configuration.answer
    : answerConfiguration;

  return (
    <RadioSurveyFS>
      <input
        type="radio"
        id={`radioButton-${elementKey}`}
        name={`radioButton-${idQuestion}`}
        defaultValue={elementValue}
        onChange={handleRadioChange}
      />
      <label style={labelStyle} id="labelRadioSurvey">
        {elementValue}
      </label>
    </RadioSurveyFS>
  );
};

RadioButtonComponent.propTypes = {
  surveyQuestionData: PropTypes.object,
  answerConfiguration: PropTypes.object,
  QuestionsSave: PropTypes.array,
  setQuestionsSave: PropTypes.func,
  elementKey: PropTypes.string,
  elementValue: PropTypes.string,
  setAnswerQuestion: PropTypes.func,
  idQuestion: PropTypes.string,
  internalCode: PropTypes.array,
  typeQuestion: PropTypes.string,
  configuration: PropTypes.object,
  question: PropTypes.object,
  answersDependent: PropTypes.array.isRequired,
  setAnswersDependent: PropTypes.func,
};

export default RadioButtonComponent;
